const state= {
    ApprovalItems:{
        data:[],
        total:0,
    }
};

const getters = {
    ApprovalItems : (state) => state.ApprovalItems,
};


const actions = {
  async getApprovalItems({commit}, params){
      return new Promise (( resolve, reject ) => {
          global.axios.get(`api/approval`, {params:params})
              .then(response => {
                  commit( 'setApprovalItems', response.data.data );
                  resolve( response.data.data );
              })
              .catch(error => reject( error ));
      });
  },

  async createApproval({commit}, params){
      return new Promise (( resolve, reject ) => {
          global.axios.post(`api/approval`, params)
              .then(response => {
                  commit( 'createApproval', response.data.data );
                  resolve( response.data.data );
              })
              .catch(error => reject( error ));
      });
  },
    async updateApproval({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/approval/`+ params.id, params)
                .then(response => {
                    resolve( response );
                })
        });
    },
  async saveSequence({commit}, params){
      return new Promise (( resolve, reject ) => {
            global.axios.put(`/api/approval/level`, params)
            .then(response => {
                resolve(response);
            })
            .catch(error => reject( error ));
      });
  },

  async deleteApproval({commit}, params) {
    return new Promise((resolve, reject) => {
        global.axios.delete(`api/approval`, {
            data: params
        })
        .then(response => {
            resolve(response);
        })
        .catch(error => reject(error));
    })
  },
  async updateAndNewApproval({commit}, params){
    return new Promise (( resolve, reject ) => {
        global.axios.put(`api/approval/${params.id}/new-version`, params)
            .then(response => {
                resolve( response );
            })
    });
  },
}

const mutations = {
    setApprovalItems (state, data) {
      state.ApprovalItems = data;
    },
    createApproval(state, data) {
      state.ApprovalItems = [...state.ApprovalItems.items, data];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
